import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Checkbox } from "../../components/ui/checkbox";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Textarea } from "../../components/ui/textarea";

export function CheckInTab({
  students, displayName, getUncheckedStudents, getSortedStudents, getStudentScheduledTime,
  onTimeCheckins, setOnTimeCheckins, tardyStudent, setTardyStudent, tardyTime, setTardyTime,
  tardyType, setTardyType, tardyExcused, setTardyExcused, tardyNotes, setTardyNotes,
  handleBulkCheckIn, handleTardyCheckIn,
}) {
  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>On-Time Arrivals</CardTitle>
          <CardDescription>Default check-in time: 8:30 AM</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-4">
            {getUncheckedStudents().map((student) => {
              const schedTime = getStudentScheduledTime(student, 'start');
              const isCustomTime = schedTime !== "08:30";
              return (
                <div
                  key={student.id}
                  onClick={() => setOnTimeCheckins((prev) => ({ ...prev, [student.id]: !prev[student.id] }))}
                  className="flex items-center space-x-3 p-3 rounded-lg border hover:bg-muted/50 transition-colors cursor-pointer select-none"
                  data-testid={`checkin-row-${student.id}`}
                >
                  <Checkbox
                    id={`checkin-${student.id}`}
                    checked={onTimeCheckins[student.id] || false}
                    onCheckedChange={(checked) =>
                      setOnTimeCheckins((prev) => ({ ...prev, [student.id]: checked }))
                    }
                    className="pointer-events-none"
                    data-testid={`checkin-checkbox-${student.id}`}
                  />
                  <span>
                    {displayName(student)} {student.last_name}
                    {isCustomTime && (
                      <span className="block text-xs text-blue-600 font-normal">Expected: {schedTime}</span>
                    )}
                  </span>
                </div>
              );
            })}
          </div>
          {getUncheckedStudents().length === 0 && (
            <p className="text-muted-foreground text-center py-4">All students have been checked in</p>
          )}
          <Button
            onClick={handleBulkCheckIn}
            className="bg-[#00305E] hover:bg-[#00305E]/90"
            disabled={Object.values(onTimeCheckins).filter(Boolean).length === 0}
            data-testid="bulk-checkin-btn"
          >
            Check In Selected ({Object.values(onTimeCheckins).filter(Boolean).length})
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Tardy / Alternate Plan Arrival</CardTitle>
          <CardDescription>Record late arrivals with timestamp</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Student</Label>
              <Select value={tardyStudent} onValueChange={setTardyStudent}>
                <SelectTrigger data-testid="tardy-student-select">
                  <SelectValue placeholder="Select student" />
                </SelectTrigger>
                <SelectContent>
                  {getSortedStudents().map((student) => (
                    <SelectItem key={student.id} value={student.id}>
                      {displayName(student)} {student.last_name}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Arrival Time (leave blank for current time)</Label>
              <Input type="time" value={tardyTime} onChange={(e) => setTardyTime(e.target.value)} data-testid="tardy-time-input" />
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Type</Label>
              <Select value={tardyType} onValueChange={setTardyType}>
                <SelectTrigger data-testid="tardy-type-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="planned">Planned</SelectItem>
                  <SelectItem value="unplanned">Unplanned</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label>Status</Label>
              <Select value={tardyExcused ? "excused" : "unexcused"} onValueChange={(v) => setTardyExcused(v === "excused")}>
                <SelectTrigger data-testid="tardy-status-select"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="excused">Excused</SelectItem>
                  <SelectItem value="unexcused">Unexcused</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="space-y-2">
            <Label>Notes</Label>
            <Textarea placeholder="Add any notes..." value={tardyNotes} onChange={(e) => setTardyNotes(e.target.value)} data-testid="tardy-notes" />
          </div>
          <Button onClick={handleTardyCheckIn} className="bg-amber-600 hover:bg-amber-700" data-testid="tardy-checkin-btn">
            Record Tardy Arrival
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
